import styled from 'styled-components';
import colors from 'assets/styles/colors';
import SectionContainer from '../containers/SectionContainer';

export const FundraiseDeviceContainer = styled(SectionContainer)`
  background-color: ${colors.blue};
  display: flex;
  align-items: center;
`;
